// extracted by css-extract-rspack-plugin
export default {"stars":"index__stars___AZcHg","starsSmall":"index__starsSmall___Nydfm","starsMini":"index__starsMini___cVY0y","starsLarge":"index__starsLarge___t_7aV"};